import dayjs from "dayjs";
import { PortfolioItemModel } from "../../../features/portfolio-info/types/PortfolioItemModel";
import { AssetType } from "../../types/AssetType";
import { blackScholesModelCalculationService } from "../BlackScholesModelCalculationService";
import { BaseCalculationService } from "./BaseCalculationService";

export class GammaCalculationService extends BaseCalculationService {
    protected calculateForFutures(_: PortfolioItemModel): number {
        return 0;
    }

    protected calculateForOption(item: PortfolioItemModel,
        underlyingPrice: number, timeToExpirationInShareOfYear: number
    ): number {
        const isExpired = item.expireAt !== null
            ? blackScholesModelCalculationService.getTimeToExpirationInShareOfYear(item.expireAt, dayjs().toDate()) < 0
            : true;

        if (isExpired) {
            // todo: calc option price after expiration
            return 0;
        }
        
        if (item.markImpliedVolatility === null) {
            throw new Error("ImpliedVolatility cannot be null!");
        }

        if (item.strike === null) {
            throw new Error("Portfolio item property 'strike' is null.")
        }
        
        return blackScholesModelCalculationService.getGamma(
            underlyingPrice, item.strike, timeToExpirationInShareOfYear, item.markImpliedVolatility);
    }

    protected getMinTimeToExpirationInShareOfYear(): number {
        return 1 / 365;
    }
}